import {
  IsString,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsArray,
  IsIn,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { DeadlineSettings } from '@app/gen/settings';

import { ExecutorFieldsDto } from './executor-fields.dto';
import { DeadlineDto } from './deadline.dto';

export class BaseTaskDto extends ExecutorFieldsDto {
  @IsString()
  @IsOptional()
  stageDescription?: string;

  @IsString()
  @IsOptional()
  hasDeadline?: string;

  @ValidateIf((dto: BaseTaskDto) => dto.hasDeadline === 'true')
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => DeadlineDto)
  deadline?: DeadlineDto[];

  @ValidateIf(
    (dto: BaseTaskDto) =>
      dto.hasDeadline === 'true' && (dto.deadline?.length ?? 0) > 1,
  )
  @IsIn(['min_date', 'max_date'], { message: 'Обязательное поле' })
  deadlineMode?: DeadlineSettings['mode'];

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  companyCancelable: boolean;

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  employeeCancelable: boolean;

  @IsString()
  @IsOptional()
  parallelGroupId?: string;

  isFirstNode?: boolean;
}
